import { Box, CircularProgress } from '@mui/material';

/**
 * What stands on screen while the session is being checked — or while a signed-in person is being
 * sent on from a public page. Never the protected content, and never the login form: showing either
 * for a moment before the answer arrives is the flash this exists to prevent.
 */
export default function AuthLoader() {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}
